module.exports = __webpack_public_path__ + "static/img/egg_r_07.6a215be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_07.png
// module id = SWrW
// module chunks = 1